// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            data: [
                // {
                //     name: 'Cinema4D + Octane',
                //     value: 4
                // },
                {
                    name: 'Cinema4D',
                    value: 1
                },
                {
                    name: 'Redshift',
                    value: 2
                },
                {
                    name: 'Cinema4D + Redshift',
                    value: 5
                },
                // {
                //     name: 'Octane',
                //     value: 3
                // },
            ],

            softwareLicenseId: 5,
            softwareLicenseEnabled: false,

            dataNote: [
                {
                    label: 'Some things to note when fixed MAC address',
                    children: [
                        {
                            label: '• This feature will help you to fix our physical hardware for the next time you boot your computer.',
                        },
                        {
                            label: '• You will not be able to boot the machine if the physical machine you fixed is in use.',
                        },
                    ]
                },
            ],
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    mounted() {
        if (this.targetImage != null) {
            // if (this.targetImage.softwareLicenseId === 0) this.targetImage.softwareLicenseId = 5;
            // this.softwareLicenseId = this.softwareLicenseId === 0 ? 5 : this.targetImage.softwareLicenseId;
            this.softwareLicenseId = 5;
            this.softwareLicenseEnabled = this.targetImage.softwareLicenseEnabled;
        }
    },

    methods: {

        // Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.ACTIVATE_SOFTWARE_LICENSE);
        },

        //#region Hardware fixation
        confirm() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    softwareLicenseId: this.softwareLicenseId,
                    enabled: !this.softwareLicenseEnabled,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.ACTIVATE_SOFTWARE_LICENSE, data)
                    .then(() => {
                        EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                        EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                        this.closeThisPopup();
                        this.notificationSuccess(
                            this.$t(data.enabled ? 'activateSoftwareLicenseModal.successTitleEnabled' : 'activateSoftwareLicenseModal.successTitleDisabled'),
                            this.$t(data.enabled ? 'activateSoftwareLicenseModal.successMessageEnabled' : 'activateSoftwareLicenseModal.successMessageDisabled', { id: this.targetImage.id, name: this.targetImage.name })
                        );
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                        switch (error.errorCode) {
                            case 7:
                            case 3:
                                this.$store.dispatch("common/showCommonError", error);
                                break;
                            default:
                                this.processCatchApiRequest(error, this.$t('activateSoftwareLicenseModal.failedMessage'))
                                break;
                        }
                    });
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}